import React from 'react'
import { Helmet } from 'react-helmet'
import Navigation from '../components/navigation'
import Footer from '../components/footer'
import { usePageView } from '../hooks/useAnalytics'
import './privacy-policy.css'

const CGV = () => {
  usePageView('CGV')

  return (
    <div className="privacy-policy-container">
      <Helmet>
        <title>Terms of Sale / Conditions Générales de Vente - ORRAM Frames</title>
        <meta name="description" content="ORRAM Frames General Terms and Conditions of Sale" />
      </Helmet>
      <Navigation />
      <main className="privacy-policy-main">
        <div className="privacy-policy-content">

          {/* ENGLISH */}
          <div className="privacy-policy-header">
            <h1 className="privacy-policy-title">General Terms and Conditions of Sale</h1>
            <p className="privacy-policy-updated">ORRAM – Bespoke luxury frame maker</p>
          </div>

          <div className="privacy-section">
            <div className="company-info-box">
              <p><strong>ORRAM</strong></p>
              <p>SIRET: 379 892 433</p>
              <p>Registered office: 10 place de l'Ormeau, 83990 Saint-Tropez, FRANCE</p>
              <p>Email: <a href="mailto:orders@orram.shop">orders@orram.shop</a></p>
            </div>
          </div>

          <div className="privacy-section">
            <h2>1. Seller Identity</h2>
            <p>These General Terms and Conditions of Sale (GTC) govern the contractual relationship between ORRAM (hereinafter "the House" or "the Seller") and any person making a purchase through the website (hereinafter "the Client").</p>
          </div>

          <div className="privacy-section">
            <h2>2. Purpose</h2>
            <p>These GTC define the rights and obligations of the parties in connection with the online sale of bespoke luxury frames. Each creation is designed as a unique piece, combining artisanal craftsmanship, exceptional materials, and aesthetic excellence.</p>
          </div>

          <div className="privacy-section">
            <h2>3. Products</h2>
            <p>The products offered on the ORRAM website are high-end frames, fully customised according to the Client's choices: dimensions, finishes, ornaments, and specific options. The House takes the greatest care in presenting its products. However, due to the artisanal nature and the noble materials used, subtle variations may exist and contribute to the unique character of each piece.</p>
          </div>

          <div className="privacy-section">
            <h2>4. Order Process</h2>
            <p>Any order implies:</p>
            <ul className="privacy-list">
              <li>The selection and validation of product specifications</li>
              <li>Unconditional acceptance of these GTC</li>
              <li>Full payment</li>
            </ul>
            <p>The order becomes firm and final after confirmation by the Seller. The Seller reserves the right to refuse any order in the event of a prior dispute or payment default.</p>
          </div>

          <div className="privacy-section">
            <h2>5. Prices</h2>
            <p>Prices are expressed in euros (€), inclusive of all taxes (VAT included), including delivery costs. They reflect the quality of materials, the complexity of manufacturing, and the exclusive nature of the frames. The Seller reserves the right to modify prices at any time, without affecting already confirmed orders.</p>
          </div>

          <div className="privacy-section">
            <h2>6. Payment</h2>
            <p>Payment is made online via secure solutions. Manufacturing begins only upon receipt of full payment.</p>
            <p>For payment by bank transfer, the Seller's bank details are:</p>
            <div className="company-info-box">
              <p>Account holder: M ALEKSANDAR VUKOVIC EI ORRAM</p>
              <p>Bank: LCL - Saint Tropez</p>
              <p>IBAN: FR47 3000 2039 3600 0007 4180 Q21</p>
              <p>BIC: CRLYFRPP</p>
            </div>
          </div>

          <div className="privacy-section">
            <h2>7. Bespoke Manufacturing</h2>
            <p>As each piece is made to order, manufacturing begins after final validation of the order. Production lead times are provided as guidance and take into account the House's quality requirements.</p>
          </div>

          <div className="privacy-section">
            <h2>8. Delivery</h2>
            <p>Frames are shipped to the address provided by the Client. Delivery times depend on the destination and the selected carrier. The Seller cannot be held responsible for delays attributable to the carrier, but undertakes to assist the Client diligently in the event of an incident.</p>
          </div>

          <div className="privacy-section">
            <h2>9. Right of Withdrawal</h2>
            <p>In accordance with Article L221-28 of the French Consumer Code, the right of withdrawal does not apply to personalised goods or goods made according to the Client's specifications. Therefore, any order for a bespoke frame is final and cannot be cancelled or refunded.</p>
          </div>

          <div className="privacy-section">
            <h2>10. Receipt and Claims</h2>
            <p>The Client is invited to check the condition of the package upon receipt. Any anomaly (damaged or non-conforming product) must be reported within 24 hours, accompanied by supporting evidence (photographs, detailed description). The House undertakes to provide an appropriate response as soon as possible.</p>
          </div>

          <div className="privacy-section">
            <h2>11. Legal Guarantees</h2>
            <p>Products benefit from the legal guarantees provided by French law:</p>
            <ul className="privacy-list">
              <li>Legal guarantee of conformity (Articles L217-3 et seq. of the Consumer Code)</li>
              <li>Guarantee against hidden defects (Articles 1641 et seq. of the Civil Code)</li>
            </ul>
            <p>These guarantees exclude any deterioration due to inappropriate use, impact, or lack of maintenance.</p>
          </div>

          <div className="privacy-section">
            <h2>12. Liability</h2>
            <p>The House's liability is strictly limited to the amount of the order. It cannot be held liable for indirect or intangible damages related to the use of the products.</p>
          </div>

          <div className="privacy-section">
            <h2>13. Intellectual Property</h2>
            <p>All elements of the website (texts, visuals, graphic identity, concept) are protected by intellectual property law. Any reproduction, distribution, or exploitation without prior written authorisation is strictly prohibited.</p>
          </div>

          <div className="privacy-section">
            <h2>14. Personal Data</h2>
            <p>Personal data collected is necessary for order processing and the commercial relationship. In accordance with the General Data Protection Regulation (GDPR), the Client has the right to access, rectify, and delete their data.</p>
          </div>

          <div className="privacy-section">
            <h2>15. Mediation and Disputes</h2>
            <p>In the event of a dispute, an amicable solution will be sought as a priority. In accordance with the provisions of the Consumer Code, the Client may use a free mediation service. Mediator: A.S.VUKOVIC, head of the "Ambassadeur" service. Failing an amicable agreement, French courts shall have sole jurisdiction.</p>
          </div>

          <div className="privacy-section">
            <h2>16. Applicable Law</h2>
            <p>These GTC are governed by French law.</p>
          </div>

          <div className="privacy-section">
            <h2>17. Contact</h2>
            <div className="contact-info-box">
              <p>Customer service: 09 52 05 91 97</p>
              <p>Email: <a href="mailto:orders@orram.shop">orders@orram.shop</a></p>
              <p>Address: 10 place de l'Ormeau, 83990 Saint-Tropez, FRANCE</p>
            </div>
          </div>

          {/* FRENCH */}
          <hr style={{ margin: '4rem 0', borderColor: '#e5e5e5' }} />

          <div className="privacy-policy-header">
            <h1 className="privacy-policy-title">Conditions Générales de Vente (CGV)</h1>
            <p className="privacy-policy-updated">ORRAM – Créateur de cadres d'exception sur mesure</p>
          </div>

          <div className="privacy-section">
            <h2>1. Identité du Vendeur</h2>
            <p>Les présentes Conditions Générales de Vente (CGV) régissent les relations contractuelles entre ORRAM (ci-après « la Maison » ou « le Vendeur ») et toute personne procédant à un achat via le site internet (ci-après « le Client »).</p>
          </div>

          <div className="privacy-section">
            <h2>2. Objet</h2>
            <p>Les présentes CGV définissent les droits et obligations des parties dans le cadre de la vente en ligne de cadres de luxe réalisés sur mesure. Chaque création est conçue comme une pièce unique, alliant savoir-faire artisanal, matériaux d'exception et exigence esthétique.</p>
          </div>

          <div className="privacy-section">
            <h2>3. Produits</h2>
            <p>Les produits proposés sur le site ORRAM sont des cadres haut de gamme, entièrement personnalisés selon les choix du Client : dimensions, finitions, ornements et options spécifiques. La Maison apporte le plus grand soin à la présentation des produits. Toutefois, en raison de la nature artisanale et des matériaux nobles utilisés, de subtiles variations peuvent exister et participent au caractère unique de chaque pièce.</p>
          </div>

          <div className="privacy-section">
            <h2>4. Processus de commande</h2>
            <p>Toute commande implique :</p>
            <ul className="privacy-list">
              <li>La sélection et validation des caractéristiques du produit</li>
              <li>L'acceptation sans réserve des présentes CGV</li>
              <li>Le règlement intégral</li>
            </ul>
            <p>La commande devient ferme et définitive après confirmation par le Vendeur. Le Vendeur se réserve le droit de refuser toute commande en cas de litige antérieur ou de défaut de paiement.</p>
          </div>

          <div className="privacy-section">
            <h2>5. Prix</h2>
            <p>Les prix sont exprimés en euros (€), toutes taxes comprises (TTC), y compris les frais de livraison. Ils reflètent la qualité des matériaux, la complexité de fabrication et le caractère exclusif des cadres. Le Vendeur se réserve le droit de modifier ses tarifs à tout moment, sans incidence sur les commandes déjà validées.</p>
          </div>

          <div className="privacy-section">
            <h2>6. Paiement</h2>
            <p>Le paiement s'effectue en ligne via des solutions sécurisées. La fabrication ne débute qu'à réception du règlement intégral.</p>
            <p>Pour un paiement par virement bancaire, les coordonnées bancaires du Vendeur sont les suivantes :</p>
            <div className="company-info-box">
              <p>Titulaire du compte : M ALEKSANDAR VUKOVIC EI ORRAM</p>
              <p>Banque : LCL - Saint Tropez</p>
              <p>IBAN : FR47 3000 2039 3600 0007 4180 Q21</p>
              <p>BIC : CRLYFRPP</p>
            </div>
          </div>

          <div className="privacy-section">
            <h2>7. Fabrication sur mesure</h2>
            <p>Chaque pièce étant réalisée à la demande, la fabrication débute après validation définitive de la commande. Les délais de production sont communiqués à titre indicatif et tiennent compte des exigences de qualité propres à la Maison.</p>
          </div>

          <div className="privacy-section">
            <h2>8. Livraison</h2>
            <p>Les cadres sont expédiés à l'adresse indiquée par le Client. Les délais de livraison dépendent de la destination et du transporteur sélectionné. Le Vendeur ne saurait être tenu responsable des retards imputables au transporteur, mais s'engage à accompagner le Client avec diligence en cas d'incident.</p>
          </div>

          <div className="privacy-section">
            <h2>9. Droit de rétractation</h2>
            <p>Conformément à l'article L221-28 du Code de la consommation, le droit de rétractation ne s'applique pas aux biens personnalisés ou confectionnés selon les spécifications du Client. Ainsi, toute commande de cadre sur mesure est définitive et ne peut faire l'objet d'une annulation ou d'un remboursement.</p>
          </div>

          <div className="privacy-section">
            <h2>10. Réception et réclamations</h2>
            <p>Le Client est invité à vérifier l'état du colis à réception. Toute anomalie (produit endommagé, non conforme) devra être signalée dans un délai de 24 heures, accompagnée d'éléments justificatifs (photographies, description détaillée). La Maison s'engage à apporter une réponse adaptée dans les meilleurs délais.</p>
          </div>

          <div className="privacy-section">
            <h2>11. Garanties légales</h2>
            <p>Les produits bénéficient des garanties légales prévues par le droit français :</p>
            <ul className="privacy-list">
              <li>Garantie légale de conformité (articles L217-3 et suivants du Code de la consommation)</li>
              <li>Garantie contre les vices cachés (articles 1641 et suivants du Code civil)</li>
            </ul>
            <p>Ces garanties excluent toute détérioration liée à une utilisation inappropriée, à un choc ou à un défaut d'entretien.</p>
          </div>

          <div className="privacy-section">
            <h2>12. Responsabilité</h2>
            <p>La responsabilité de la Maison est strictement limitée au montant de la commande. Elle ne saurait être engagée pour des dommages indirects ou immatériels liés à l'utilisation des produits.</p>
          </div>

          <div className="privacy-section">
            <h2>13. Propriété intellectuelle</h2>
            <p>L'ensemble des éléments du site (textes, visuels, identité graphique, concept) est protégé par le droit de la propriété intellectuelle. Toute reproduction, diffusion ou exploitation sans autorisation écrite préalable est strictement interdite.</p>
          </div>

          <div className="privacy-section">
            <h2>14. Données personnelles</h2>
            <p>Les données personnelles collectées sont nécessaires au traitement des commandes et à la relation commerciale. Conformément au Règlement Général sur la Protection des Données (RGPD), le Client dispose d'un droit d'accès, de rectification et de suppression de ses données.</p>
          </div>

          <div className="privacy-section">
            <h2>15. Médiation et litiges</h2>
            <p>En cas de litige, une solution amiable sera recherchée avec priorité. Conformément aux dispositions du Code de la consommation, le Client peut recourir gratuitement à un service de médiation. Médiateur : A.S.VUKOVIC responsable du service « Ambassadeur ». À défaut d'accord amiable, les tribunaux français seront seuls compétents.</p>
          </div>

          <div className="privacy-section">
            <h2>16. Droit applicable</h2>
            <p>Les présentes CGV sont régies par le droit français.</p>
          </div>

          <div className="privacy-section">
            <h2>17. Contact</h2>
            <div className="contact-info-box">
              <p>Service client : 09 52 05 91 97</p>
              <p>Email : <a href="mailto:orders@orram.shop">orders@orram.shop</a></p>
              <p>Adresse : 10 place de l'Ormeau, 83990 Saint-Tropez, FRANCE</p>
            </div>
          </div>

        </div>
      </main>
      <Footer />
    </div>
  )
}

export default CGV
